export default "__VITE_ASSET__DGrayG9a__"